import * as Yup from "yup";

export function initialValues() {
  return {
    roleId: "",
    permissionId: "",
  };
}

export function validationSchema() {
  return Yup.object({
    permissionId: Yup.string().required("El permiso es obligatorio"),
    section: Yup.string().required("La sección es obligatoria"),
  });
}
